import { ReactNode, useRef, useMemo } from "react"
import ChevronDownFill from "~icons/eva/chevron-down-fill"
import styles from "./styles.module.scss"
import classNames from "classnames"
import { observer } from "mobx-react-lite"
import { makeAutoObservable } from "mobx"

interface AccordionProps {
  title: string
  children: ReactNode
  isActive?: boolean
}

class AccordionState {
  isOpen: boolean

  constructor() {
    this.isOpen = false

    makeAutoObservable(this)
  }

  toggle() {
    this.isOpen = !this.isOpen
  }
}

export const Accordion = observer(({ title, children, isActive = false }: AccordionProps) => {
  const state = useMemo(() => new AccordionState(), [])
  const contentRef = useRef<HTMLDivElement>(null)

  const contentHeight = state.isOpen ? `${contentRef.current?.scrollHeight}px` : "0px"

  return (
    <div className={styles.accordion}>
      <button
        className={classNames(styles.trigger, isActive && styles.triggerActive)}
        onClick={() => state.toggle()}
        aria-expanded={state.isOpen}
      >
        <span>{title}</span>
        <span className={`${styles.icon} ${state.isOpen ? styles.open : ""}`}>
          <ChevronDownFill className={styles.chevronDown} />
        </span>
      </button>
      <div
        ref={contentRef}
        className={styles.content}
        style={{ height: contentHeight }}
        aria-hidden={!state.isOpen}
      >
        <div className={styles.contentInner}>{children}</div>
      </div>
    </div>
  )
})
